"use client";

import { useTranslations } from "next-intl";
import { useUser } from "@/hooks/user/useUser";
import { useGeolocationPermission } from "@/hooks/location/useGeolocationPermission";
import { useUserLocation } from "@/hooks/location/useUserLocation";
import { Typography } from "@/components/Typography";

/**
 * Render the user greeting and request location access on page load.
 * @returns
 */
const Greeting = () => {
  const t = useTranslations("Greeting");
  const { data: user } = useUser();
  const geolocationPermission = useGeolocationPermission();

  // Request location on page load unless the browser already denied access.
  const { data: userLocation } = useUserLocation({
    enabled: geolocationPermission !== "denied",
  });
  const displayName = `${user?.firstName ?? ""} ${user?.lastName ?? ""}`.trim();
  const displayLocation =
    userLocation?.city && userLocation?.country
      ? `${userLocation.city}, ${userLocation.country}`
      : userLocation?.city;

  return (
    <div className="pt-10 pb-5 md:pb-0 md:absolute md:bottom-[230px] md:left-0 md:pt-0">
      <div className="max-w-[620px] text-white">
        <Typography variant="h5" className="text-white md:hidden">
          {t("greeting")}
          {displayName ? ` ${displayName}` : ""}!
        </Typography>
        <Typography variant="h2" className="text-white hidden md:block">
          {t("greeting")}
          {displayName ? ` ${displayName}` : ""}!
        </Typography>

        <Typography variant="h5" className="mt-2 text-white md:hidden">
          {displayLocation}
        </Typography>

        <Typography
          variant="subtitle1"
          className="mt-2 text-white hidden md:block"
        >
          {displayLocation}
        </Typography>
      </div>
    </div>
  );
};

export default Greeting;
